/**
 * AEM super class for components
 */
import { hasWindow } from "@utils/general";

export class PureAemComponent {
    element: HTMLElement;
    props: DOMStringMap;

    constructor(element: HTMLElement) {
        this.element = element;
        this.props = this.element.dataset;
    }
}

/**
 * Register a new Component to AEM
 *
 * @param selector
 * @param componentClass
 */
export function registerComponent(selector: string, componentClass: any) {
    if (!hasWindow()) {
        return;
    }

    const hook = (selector: string, componentClass: any) => {
        for (let element of document.querySelectorAll(selector)) {
            new componentClass(element);
        }
    };
    if (/complete|interactive|loaded/.test(document.readyState)) {
        // In case the document has finished parsing, document's readyState will
        // be one of "complete", "interactive" or (non-standard) "loaded".
        hook(selector, componentClass);
    } else {
        // The document is not ready yet, so wait for the DOMContentLoaded event
        document.addEventListener(
            "DOMContentLoaded",
            () => {
                hook(selector, componentClass);
            },
            false,
        );
    }
}
